import { useEffect, useState } from 'react';
import { ApiError, getMe } from './api';

export type AdminStatus = 'loading' | 'in' | 'out';

/**
 * Calls `/v1/admin/me` once on mount and reports whether the current
 * browser session has a valid admin cookie. Route guards consume this
 * hook to redirect to `/admin/login` on `out`.
 */
export function useAdmin(): { status: AdminStatus } {
  const [status, setStatus] = useState<AdminStatus>('loading');

  useEffect(() => {
    let cancelled = false;
    getMe()
      .then(() => {
        if (!cancelled) setStatus('in');
      })
      .catch((err) => {
        if (cancelled) return;
        if (err instanceof ApiError && err.status === 401) setStatus('out');
        else setStatus('out');
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { status };
}
